import { useEffect, useSyncExternalStore } from "react";
import systemSettingsService from "../services/systemSettingsService";

export default function useSystemSettings() {
  const settings = useSyncExternalStore(systemSettingsService.subscribe, systemSettingsService.getSnapshot);
  useEffect(() => {
    const refresh = () => { systemSettingsService.load().catch(() => {}); };
    refresh();
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, []);
  return settings;
}
